import { render } from "./AddressEndorsementsView.vue?vue&type=template&id=5f5e2799&scoped=true"
import script from "./AddressEndorsementsView.vue?vue&type=script&lang=js"
export * from "./AddressEndorsementsView.vue?vue&type=script&lang=js"

import "./AddressEndorsementsView.vue?vue&type=style&index=0&id=5f5e2799&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5e2799"]])

export default __exports__